export enum EWebSocketStatus {
  CONNECTING = 'CONNECTING',
  CONNECTED = 'CONNECTED',
  DISCONNECTED = 'DISCONNECTED',
  ERROR = 'ERROR',
}

export enum EWebSocketMessage {
  //SYSTEM
  AUTHENTICATE = 'authenticate',
  ROOM_JOINED = 'room_joined',
  CONNECT = 'connect',
  AUTH_SUCCESS = 'auth_success',
  ERROR = 'error',
  //CUSTOM
  CHAT_AVATAR_UPDATED = 'chat_avatar_updated',
  BALANCE_UPDATE = 'balance_update',
  CHAT_VIDEO_INJECT = 'chat_video_inject',
  VIDEO_GENERATION_PROGRESS = 'video_generation_progress',
  CHAT_MESSAGE_INJECT = 'chat_message_inject',
  CHAT_IMAGE_INJECT = 'chat_image_inject',
  CHAT_WORKFLOW_STORAGE_UPDATED = 'chat_workflow_storage_updated',
}
